import * as settings from './appsettings.json';

const API_URL = settings.API_URL;

export const API_URL_POSLOG = `${API_URL}pos/poslog`

// Receipt
export const API_URL_CREATE_RECEIPT = `${API_URL}pos/createReceipt`
export const API_URL_SAVE_RECEIPT = `${API_URL}pos/saveReceipt`
export const API_URL_CANCEL_RECEIPT = `${API_URL}pos/cancelReceipt`
export const API_URL_REPRINT_RECEIPT = `${API_URL}pos/reprintReceipt`
export const API_URL_PRINT_TEST = `${API_URL}pos/printTest`
export const API_URL_PRINT_NOTA = `${API_URL}pos/printNota`
export const API_URL_GET_PAYMENT_METHODS = `${API_URL}pos/listpaymentmethods/`
export const API_URL_GET_COUNTRIES = `${API_URL}pos/listcountries`
export const API_URL_GET_CUSTOMERGROUPS = `${API_URL}pos/listcustomergroups`
export const API_URL_GET_LABELS = `${API_URL}pos/listlabels`
export const API_URL_GET_DEVICES = `${API_URL}device/listbyposid/`
export const API_URL_ZREPORT = `${API_URL}pos/zreport`
export const API_URL_XREPORT = `${API_URL}pos/xreport`
export const API_URL_OBJECTREPORT = `${API_URL}pos/objectreport`
export const API_URL_GETHISTORYXZ = `${API_URL}pos/gethistoryxz`
export const API_URL_PRINTHISTORYXZ = `${API_URL}pos/printhistoryxz`
export const API_URL_PRINTARTICLEREPORT = `${API_URL}pos/articlereport`
export const API_URL_LIST_CONFIGURATION = `${API_URL}pos/listarticleconfigurationstep`
export const API_URL_LIST_ARTICLES = `${API_URL}pos/listarticlebypos/`
export const API_URL_LIST_PRICELIST = `${API_URL}pos/listpricelist`
export const API_URL_CLOSE_RECEIPT = `${API_URL}pos/closereceipt/`
export const API_URL_OPEN_RECEIPT_BY_ID = `${API_URL}pos/openreceiptbyid/`
export const API_URL_OPEN_RECEIPT_BY_OBJECTITEM = `${API_URL}pos/openreceiptbyobjectitem/`
export const API_URL_SPLIT_RECEIPT = `${API_URL}pos/splitreceipt/`
export const API_URL_WORKIN = `${API_URL}pos/workin`
export const API_URL_WORKOUT = `${API_URL}pos/workout`
export const API_URL_BLACKBOXRECEIPT = `${API_URL}pos/setblackboxreceiptid`
export const API_URL_OPENDRAWER = `${API_URL}pos/opendrawer`
export const API_URL_STARTPAYMENT = `${API_URL}pos/startpayment`
export const API_URL_ABORTPAYMENT = `${API_URL}pos/abortpayment`
export const API_URL_SALDOPAYMENT = `${API_URL}pos/saldopayment`
export const API_URL_TRANSFER_RECEIPT = `${API_URL}pos/transferreceipt`
export const API_URL_MERGE_RECEIPT = `${API_URL}pos/mergereceipt`
export const API_URL_COMBINE_OBJECTS = `${API_URL}pos/combineobjects`
export const API_URL_BARCODESCANNED = `${API_URL}pos/barcodescanned`
export const API_URL_SCALETEST = `${API_URL}pos/scaletest/`
export const API_URL_STARTWEIGHARTICLE = `${API_URL}pos/weigharticle`
export const API_URL_ABORTWEIGH = `${API_URL}pos/abortweigh`
export const API_URL_SAVE_STEP = `${API_URL}pos/savestep`
export const API_URL_GET_ORDERS = `${API_URL}pos/getorders`
export const API_URL_PAY_ORDER = `${API_URL}pos/payorder`
export const API_URL_PROCESS_PAYEDONWEBSHOP_PURCHASEORDER = `${API_URL}pos/processpayedonwebshoppurchaseorder`
export const API_URL_POS_DEFAULT_CHANGE_PAYMENT = `${API_URL}pos/getposdefaultchangepayment/`
export const API_URL_CHECK_TICKET_BARCODE = `${API_URL}pos/ticketbarcodeexists/`
export const API_URL_REPRINT_TICKETS = `${API_URL}pos/reprinttickets`
export const API_URL_CASH_REGISTRATION = `${API_URL}pos/cashregistration`
export const API_URL_GET_FREE_OBJECTITEM = `${API_URL}pos/getfreeobjectitem/`
export const API_URL_CLEAR_OBJECTITEM = `${API_URL}receipt/updateobjectitemstatus/`
export const API_URL_GET_ORDEROVERVIEW = `${API_URL}receipt/getorderoverview/`
export const API_URL_UPDATE_ORDER = `${API_URL}receipt/updateorder/`
export const API_URL_FETCH_DISCOUNT_MENU = `${API_URL}receipt/fetchdiscountmenu`
// License
export const API_URL_DUMMY_CHECK_LICENSE = `${API_URL}pos/checklicense`
export const API_URL_GET_LICENSES = `${API_URL}pos/getlicenses`
export const API_URL_GET_BLACKBOX = `${API_URL}pos/blackboxstatus/`
export const API_URL_GET_VERSION = `${API_URL}pos/version`
export const API_URL_GET_ID = `${API_URL}pos/uniqueid/`
export const API_URL_GET_DAYSTILLEXPIRED = `${API_URL}pos/daystillexpired`

// Users
export const API_URL_LOGIN_USER = `${API_URL}pos/loginuser`
export const API_URL_LOGOUT_USER = `${API_URL}pos/logoutuser`
export const API_URL_LIST_USERS = `${API_URL}pos/listusers`
export const API_URL_GET_USER = `${API_URL}pos/getuser/`
export const API_URL_GET_ALL_USERS = `${API_URL}pos/getallusers`
export const API_URL_POSLIST = `${API_URL}pos/listpos`
export const API_URL_STORELIST = `${API_URL}pos/liststores`
export const API_URL_COMPANYLIST = `${API_URL}pos/listcompanies`
export const API_URL_CHECK_USER = `${API_URL}pos/checkuser`
export const API_URL_GET_KIOSKTEXT = `${API_URL}pos/getkiosktext`

// File Attachments
export const API_URL_BUTTON_IMAGE = `${API_URL}pos/getimage`
export const API_URL_ARTICLE_IMAGE = `${API_URL}pos/getimagebykeyid`

// ObjectManagement
export const API_URL_OBJECTGROUPLIST = `${API_URL}pos/listobjectgroups/`
export const API_URL_OBJECTMANAGEMENT_CREATE_RECEIPT = `${API_URL}pos/createreceiptforobjectitem`
export const API_URL_LAYOUTITEMS = `${API_URL}pos/listkeylayoutitems/`

// Language
export const API_URL_GET_LANGUAGES = `${API_URL}general/getlanguages`

// Customers
export const API_URL_GETCUSTOMER = `${API_URL}pos/getcustomer/`
export const API_URL_GETSYNCCUSTOMER = `${API_URL}pos/getsynccustomer/`
export const API_URL_GET_CUSTOMERS = `${API_URL}pos/getcustomers/`
export const API_URL_GET_CUSTOMERGROUP = `${API_URL}customer/getcustomergroup/`
export const API_URL_GETCUSTOMERS_BY_LABEL = `${API_URL}pos/getcustomersbylabel/`
export const API_URL_SAVE_CUSTOMER = `${API_URL}customer/save`
export const API_URL_GET_NEW_CUSTOMER_OBJECT = `${API_URL}pos/getnewcustomerobject`
export const API_URL_GET_CUSTOMER_CARD_DATA = `${API_URL}pos/getcustomercarddata`
export const API_URL_GET_CUSTOMER_BY_NAME_AND_DATE_OF_BIRTH = `${API_URL}customer/getbynameanddateofbirth`
export const API_URL_GET_CUSTOMER_BY_IDENTIFICATIONNUMBER = `${API_URL}customer/getbyidentificationnumber`
export const API_URL_VALIDATE_VATNUMBER = `${API_URL}pos/ValidateVatNumber`

// Titlebar button
export const TITLEBAR_STATUS = 100
export const TITLEBAR_BACKOFFICE = 110
export const TITLEBAR_FUNCTION = 120
export const TITLEBAR_SHOWHIDERECEIPT = 130

// Functionbar
export const FUNCTIONBAR_NONE = 100
export const FUNCTIONBAR_STATUS = 200
export const FUNCTIONBAR_STATUS_PRINTER = 210
export const FUNCTIONBAR_STATUS_DRAWER = 220
export const FUNCTIONBAR_STATUS_SCALE = 230
export const FUNCTIONBAR_FUNCTION = 300
export const FUNCTIONBAR_FUNCTION_ZREPORT = 310
export const FUNCTIONBAR_FUNCTION_XREPORT = 320
export const FUNCTIONBAR_FUNCTION_XINFOREPORT = 325
export const FUNCTIONBAR_FUNCTION_HISTORIE = 330
export const FUNCTIONBAR_FUNCTION_ARTICLEREPORT = 335
export const FUNCTIONBAR_FUNCTION_CUSTOMERBASE = 340
export const FUNCTIONBAR_FUNCTION_UNLOCKCUSTOMER = 345;
export const FUNCTIONBAR_FUNCTION_LICENSE = 423
export const FUNCTIONBAR_FUNCTION_EXITTOWINDOWS = 500
export const FUNCTIONBAR_FUNCTION_WORKIN = 600
export const FUNCTIONBAR_FUNCTION_WORKOUT = 610
export const FUNCTIONBAR_FUNCTION_OBJECTREPORT = 620

// Cookies
export const COOKIE_POS_LASTUSERID = 'pos_lastuserid'
export const COOKIE_POS_LASTPOSID = 'pos_lastposid'
export const COOKIE_POS_UNIQUEID = 'pos_uniqueid'

//DragDrop source
export const DND_OJECTITEMBUTTON = 'ObjectItemButton'

//General
export const API_URL_GET_SYSTEM_SETTING_BY_KEY = `${API_URL}general/getsystemsettingbykey/`

// Articles
export const API_URL_GET_ALL_ARTICLES = `${API_URL}pos/listarticlebypos/`
export const API_URL_GET_ARTICLEGROUP_BY_ARTICLE = `${API_URL}article/listarticlegroupbyarticle/`
export const API_URL_GET_ARTICLES_BY_ARTICLEGROUP = `${API_URL}pos/listarticlebyarticlegroup/`

// Object
export const API_URL_SET_OBJECT_PROCESSED = `${API_URL}pos/setobjectprocessed/`

// Invoice
export const API_URL_GET_RECEIPTS_TO_INVOICE = `${API_URL}pos/getreceiptstoinvoice/`
export const API_URL_CREATE_INVOICE = `${API_URL}pos/createinvoice/`
export const API_URL_INVOICE_ACTION = `${API_URL}invoice/invoiceaction/`
export const API_URL_GET_ORIGINALINVOICE = `${API_URL}pos/getoriginalinvoice`

// Reservation
export const API_URL_GET_RECEIPT_BY_RESERVATIONNUMBER = `${API_URL}receipt/getreceiptbyreservationnumber/`
export const API_URL_SET_RESERVATION_COLLECTED = `${API_URL}receipt/setreservationcollected/`

// Keylayout
export const API_URL_GET_PAYMENT_KEY_LAYOUT_ACTION = `${API_URL}pos/getpaymentkeylayoutaction`

//Ticket
export const API_URL_CREATE_DEFAULT_TICKET = `${API_URL}ticket/createdefaultticket/`
export const API_URL_LINK_TICKET_TO_OBJECT = `${API_URL}ticket/linktickettoobject/`
export const API_URL_PRINT_TICKET_WITH_AMOUNT = `${API_URL}pos/printticketbarcodewithamount`
export const API_URL_GET_NEW_TICKET_OBJECT = `${API_URL}pos/getnewticketobject`

//Stock
export const API_URL_SET_STOCK = `${API_URL}pos/setstock`
export const API_URL_GET_STOCK_MESSAGE = `${API_URL}pos/getstockmessage`
export const API_URL_ARTICLE_AVAILABLE = `${API_URL}pos/articleavailable`
export const API_URL_GET_LATEST_TICKETS = `${API_URL}pos/getlatesttickets/`
export const API_URL_GET_TICKETS = `${API_URL}pos/gettickets/`
export const API_URL_GET_TICKETUSAGES = `${API_URL}pos/getticketusages/`  
export const API_URL_SAVE_TICKET = `${API_URL}pos/saveticket`
export const API_URL_DELETE_TICKET = `${API_URL}pos/deleteticket`

//FiscalPrinter
export const API_RESET_FISCALPRINTER = `${API_URL}pos/resetfiscalprinter/`


// WEBPACK FOOTER //
// src/constants/General.js